import { createReducer } from '../../utils/reducerBuilder';
import { RootAction } from '../../store/root';
import produce from 'immer';
import { DialogConfig, SnackbarConfig } from './models';
import actions from './actions';
import { IAsyncError } from '../../common';
import { equals } from '../../utils/helper/deep-equal';

export interface ICommonState {
  dialogs: DialogConfig[];
  snackbars: SnackbarConfig[];

  reauthenticationRequested: boolean;
  isReauthenticating: boolean;
  reauthenticationError?: IAsyncError;

  isSendingPasswordEmail: boolean;
  passwordEmailError?: IAsyncError;
  hasSentPasswordEmail: boolean;
}

const defaultState: ICommonState = {
  dialogs: [],
  snackbars: [],
  reauthenticationRequested: false,
  isReauthenticating: false,

  isSendingPasswordEmail: false,
  hasSentPasswordEmail: false,

};

const reducer = createReducer<ICommonState, RootAction>(defaultState)
  .handleAction(actions.showDialog, (state, action) =>
    produce(state, draft => {
      draft.dialogs.push(action.payload);
    })
  )
  .handleAction(actions.hideDialog, (state, action) =>
    produce(state, draft => {
      draft.dialogs = draft.dialogs.slice(1);
    })
  )
  .handleAction(actions.showSnackbar, (state, action) =>
    produce(state, draft => {
      if (!draft.snackbars.some(snackbarConfig => equals(snackbarConfig, action.payload))) {
        draft.snackbars.push(action.payload);
      }
    })
  )
  .handleAction(actions.hideSnackbar, (state, action) =>
    produce(state, draft => {
      draft.snackbars = draft.snackbars.slice(1);
    })
  )
  .handleAction(actions.reauthenticate.showDialog, (state, action) =>
    produce(state, draft => {
      draft.reauthenticationRequested = true;
      draft.reauthenticationError = undefined;
      draft.isSendingPasswordEmail = false;
      draft.hasSentPasswordEmail = false;
      draft.passwordEmailError = undefined;
    })
  )
  .handleAction(actions.reauthenticate.request, (state, action) =>
    produce(state, draft => {
      draft.reauthenticationRequested = true;
      draft.reauthenticationError = undefined;
      draft.isReauthenticating = true;
    })
  )
  .handleAction(actions.reauthenticate.success, (state, action) =>
    produce(state, draft => {
      draft.reauthenticationRequested = false;
      draft.isReauthenticating = false;
    })
  )
  .handleAction(actions.reauthenticate.failure, (state, action) =>
    produce(state, draft => {
      draft.isReauthenticating = false;
      draft.reauthenticationError = action.payload;
    })
  )
  .handleAction(actions.reauthenticate.cancel, (state, action) =>
    produce(state, draft => {
      draft.isReauthenticating = false;
      draft.reauthenticationRequested = false;
    })
  )
  .handleAction(actions.resetPassword.request, (state, action) =>
    produce(state, draft => {
      draft.isSendingPasswordEmail = true;
      draft.hasSentPasswordEmail = false;
      draft.passwordEmailError = undefined;
    })
  )
  .handleAction(actions.resetPassword.success, (state, action) =>
    produce(state, draft => {
      draft.isSendingPasswordEmail = false;
      draft.hasSentPasswordEmail = true;
    })
  )
  .handleAction(actions.resetPassword.failure, (state, action) =>
    produce(state, draft => {
      draft.isSendingPasswordEmail = false;
      draft.passwordEmailError = action.payload;
    })
  )
  .build();

export default reducer;
